import { GET_FUNCTION_MARKERS } from "../../../enums/Request/leader.requests.types";

export const getFunctionMarkerAction = (markers) => {
    return {
        type: GET_FUNCTION_MARKERS,
        payload: markers,
    };
};